import React from "react";
import type {VoidFunctionComponent} from "react";
import {useDashboardUserPointsToLevelLogic} from "./DashboardUserPointsToLevel.logic";
import {UserSummaryStatsContainer} from "../../../components/dashboard/user-stats-container/UserSummaryStatsContainer";

export const DashboardUserPointsToLevel: VoidFunctionComponent = () => {
  const {nextLevel, pointsEarnedTowardsNextLevel, pointsEarnableWithinCurrentLevel} = useDashboardUserPointsToLevelLogic();
  return <UserSummaryStatsContainer value={pointsEarnedTowardsNextLevel ?? 0} maxValue={pointsEarnableWithinCurrentLevel} label={`Points toward Level ${nextLevel}`} />;
}
